import React, { Component } from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import OPComponent from '../op_component';

import Check from './check';

export default class CheckButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  handlePress = () => {
    const { onPress, value, checked, onChecked } = this.props;
    onPress && onPress(value, !checked);
    onChecked && onChecked(!checked);
  };

  render() {
    let {
      checked,
      label,
      disabled,
      noTopBorder,
      noBottomBorder,
      containerStyle,
      labelStyle,
      iconStyle,
      disabledLabelStyle,
      renderRightView,
      value,
      item,
      iconType = 'default',
    } = this.props;
    return (
      <Pressable
        style={[
          styles.iconButton,
          noTopBorder ? { borderTopWidth: 0 } : null,
          noBottomBorder ? { borderBottomWidth: 0 } : null,
          containerStyle,
        ]}
        onPress={this.handlePress}
        disabled={disabled}
      >
        <Check
          checked={checked}
          checkSize={this.props.checkSize}
          iconStyle={iconStyle}
          iconType={iconType}
        />

        {!!label && (
          <Text
            style={[
              styles.iconButtonLabelText,
              labelStyle,
              disabled ? disabledLabelStyle || styles.disabledText : null,
            ]}
          >
            {label}
          </Text>
        )}
        {!!renderRightView && renderRightView(value, checked, item)}
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  iconButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
    paddingHorizontal: 25,
    paddingVertical: 15,
  },
  iconButtonLabelText: {
    ...FONT.regular,
    fontSize: 20,
    color: COLOR.text,
    marginLeft: 20,
  },
  iconButtonValueText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.small,
    color: COLOR.textLight,
    textAlign: 'right',
    marginRight: 20,
  },
  disabledText: {
    color: COLOR.textDisabled,
  },
});
